import apiAxios from '../../services/apiAxios';

const state = {
    list: [],
    selectList: []
};

const mutations = {
    'INICIALIZAR_SELECT_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_SELECT_LIST'(state, params) {
        state.list = params.list;
        state.selectList = params.selectList;
    },
};

const actions = {
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SELECT_LIST');

            apiAxios.get('cuentas/list')
                .then(res => {
                    let selectList = [];
                    res.data.forEach(item => {
                        selectList.push(item.nombre)
                    });
                    let params = {
                        list: res.data,
                        selectList
                    }
                    commit('SET_SELECT_LIST', params);

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
        }, error => {
            reject(error);
        })            
    },
};

const getters = {
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}